module.exports = __webpack_public_path__ + "static/img/545_phase_function_Paper_Points.5c780ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/545_phase_function_Paper_Points.png
// module id = u5A6
// module chunks = 0